import React from 'react'
import SerCardSingle from './SerCardSingle'
import Api from './Sercardapi.js'
import "./sercard.css"

const SerCard = () => {
    return (
        <>
            <div className="service-cards">
                <h1>Services</h1>
                <div className="container">
                    {
                        Api.map((curElem, index) => {
                            return <SerCardSingle
                                key={index}
                                clas={curElem.icon}
                                head={curElem.title}
                                description={curElem.desc}
                            />
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default SerCard